import resourceService from "./resource.service";

const path = 'admin/feedbacks'
const service = resourceService.init(path)


export default service
